var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navspinner  text-center"},_vm._l((3),function(variant){return _c('b-spinner',{key:variant,staticStyle:{"width":"0.7rem","height":"0.7rem"},attrs:{"variant":"light  small","type":"grow"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }